<script lang="ts" setup>
import { computed, type ComputedRef } from 'vue';
import AtaTableUnderRemittance from '../AtaTableUnderRemittance.vue';
import type { UseAtaTableUnderRemittanceLogicProps } from '../logic/useAtaTableUnderRemittanceLogic';
import AtaTableUnderRemittanceSkeleton from './AtaTableUnderRemittanceSkeleton.vue';
import { useAtaTableUnderRemittanceData } from './useAtaTableUnderRemittanceData';

export type AtaTableUnderRemittanceDataProps = { projectId: string };

const props = defineProps<AtaTableUnderRemittanceDataProps>();

const { data, isLoading } = useAtaTableUnderRemittanceData(
  () => props.projectId,
);

const logicProps: ComputedRef<UseAtaTableUnderRemittanceLogicProps> = computed(
  () => {
    const initialAtas: UseAtaTableUnderRemittanceLogicProps['initialAtas'] = (
      data.value ?? []
    ).map((ata) => ({
      id: ata.id,
      amount: ata.totalCost ?? 0,
      name: ata.title,
      number: ata.serialNumber ?? 1,
      priority: ata.priority ?? 4,
      sentDate: ata.sentDate ? new Date(ata.sentDate) : undefined,
      deadLine: ata.deadlineDate ? new Date(ata.deadlineDate) : undefined,
    }));

    return {
      initialAtas,
      projectId: props.projectId,
    };
  },
);
</script>

<template>
  <AtaTableUnderRemittanceSkeleton v-if="isLoading" />
  <AtaTableUnderRemittance v-else v-bind="logicProps" />
</template>
